import React from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import '../sass/app_hadria.scss';
import registerServiceWorker from './registerServiceWorker';
import Booking from './Booking';
import ReservationForm from './ReservationForm';

const bookingEl = document.getElementById('root')
const reservationsEl = document.getElementById('reservations')

bookingEl && ReactDOM.render(<Booking caretColor='#284B98' closeCaretColor='#D3B37F' />, bookingEl);
reservationsEl && ReactDOM.render(<ReservationForm caretColor='#284B98' />, reservationsEl);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/js/index_hadria.js